var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsEnum, IsOptional, IsString, } from 'class-validator';
import { GetManyQueryDto } from '../../../classes/common/request/get-many-query.dto';
import { ReservationConsultationType } from '../../../enums';
import { PartialType } from '../../../utils';
export class GetManyReservationConsultationsQueryDto extends PartialType(GetManyQueryDto) {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyReservationConsultationsQueryDto.prototype, "reservationId", void 0);
__decorate([
    IsEnum(ReservationConsultationType),
    IsOptional(),
    __metadata("design:type", String)
], GetManyReservationConsultationsQueryDto.prototype, "type", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyReservationConsultationsQueryDto.prototype, "fromCreatedAt", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyReservationConsultationsQueryDto.prototype, "toCreatedAt", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyReservationConsultationsQueryDto.prototype, "vehicleNumberKeyword", void 0);
